import { RootState } from '../../store';

// Roles
export const selectSystemRoles = (state: RootState) => state.superadmin.roles;
export const selectSystemRolesLoading = (state: RootState) => state.superadmin.rolesLoading;
export const selectSystemRolesError = (state: RootState) => state.superadmin.rolesError;

export const selectCreateRoleLoading = (state: RootState) => state.superadmin.createRoleLoading;
export const selectCreateRoleSuccess = (state: RootState) => state.superadmin.createRoleSuccess;
export const selectCreateRoleError = (state: RootState) => state.superadmin.createRoleError;

export const selectUpdateRoleLoading = (state: RootState) => state.superadmin.updateRoleLoading;
export const selectUpdateRoleSuccess = (state: RootState) => state.superadmin.updateRoleSuccess;
export const selectUpdateRoleError = (state: RootState) => state.superadmin.updateRoleError;

export const selectDeleteRoleLoading = (state: RootState) => state.superadmin.deleteRoleLoading;
export const selectDeleteRoleSuccess = (state: RootState) => state.superadmin.deleteRoleSuccess;
export const selectDeleteRoleError = (state: RootState) => state.superadmin.deleteRoleError;

// Modules
export const selectSystemModules = (state: RootState) => state.superadmin.modules;
export const selectSystemModulesLoading = (state: RootState) => state.superadmin.modulesLoading;
export const selectSystemModulesError = (state: RootState) => state.superadmin.modulesError;

export const selectCreateModuleLoading = (state: RootState) => state.superadmin.createModuleLoading;
export const selectCreateModuleSuccess = (state: RootState) => state.superadmin.createModuleSuccess;
export const selectCreateModuleError = (state: RootState) => state.superadmin.createModuleError;

export const selectUpdateModuleLoading = (state: RootState) => state.superadmin.updateModuleLoading;
export const selectUpdateModuleSuccess = (state: RootState) => state.superadmin.updateModuleSuccess;
export const selectUpdateModuleError = (state: RootState) => state.superadmin.updateModuleError;

export const selectDeleteModuleLoading = (state: RootState) => state.superadmin.deleteModuleLoading;
export const selectDeleteModuleSuccess = (state: RootState) => state.superadmin.deleteModuleSuccess;
export const selectDeleteModuleError = (state: RootState) => state.superadmin.deleteModuleError;

// Mappings
export const selectRoleModuleMappings = (state: RootState) => state.superadmin.mappings;
export const selectRoleModuleMappingsLoading = (state: RootState) => state.superadmin.mappingsLoading;
export const selectRoleModuleMappingsError = (state: RootState) => state.superadmin.mappingsError;

export const selectCreateMappingLoading = (state: RootState) => state.superadmin.createMappingLoading;
export const selectCreateMappingSuccess = (state: RootState) => state.superadmin.createMappingSuccess;
export const selectCreateMappingError = (state: RootState) => state.superadmin.createMappingError;

export const selectUpdateMappingLoading = (state: RootState) => state.superadmin.updateMappingLoading;
export const selectUpdateMappingSuccess = (state: RootState) => state.superadmin.updateMappingSuccess;
export const selectUpdateMappingError = (state: RootState) => state.superadmin.updateMappingError;

export const selectDeleteMappingLoading = (state: RootState) => state.superadmin.deleteMappingLoading;
export const selectDeleteMappingSuccess = (state: RootState) => state.superadmin.deleteMappingSuccess;
export const selectDeleteMappingError = (state: RootState) => state.superadmin.deleteMappingError;

// User Mappings
export const selectUserRoleMappings = (state: RootState) => state.superadmin.userMappings;
export const selectUserRoleMappingsLoading = (state: RootState) => state.superadmin.userMappingsLoading;
export const selectUserRoleMappingsError = (state: RootState) => state.superadmin.userMappingsError;

export const selectCreateUserMappingLoading = (state: RootState) => state.superadmin.createUserMappingLoading;
export const selectCreateUserMappingSuccess = (state: RootState) => state.superadmin.createUserMappingSuccess;
export const selectCreateUserMappingError = (state: RootState) => state.superadmin.createUserMappingError;

export const selectDeleteUserMappingLoading = (state: RootState) => state.superadmin.deleteUserMappingLoading;
export const selectDeleteUserMappingSuccess = (state: RootState) => state.superadmin.deleteUserMappingSuccess;
export const selectDeleteUserMappingError = (state: RootState) => state.superadmin.deleteUserMappingError;

export const selectUpdateUserMappingLoading = (state: RootState) => state.superadmin.updateUserMappingLoading;
export const selectUpdateUserMappingSuccess = (state: RootState) => state.superadmin.updateUserMappingSuccess;
export const selectUpdateUserMappingError = (state: RootState) => state.superadmin.updateUserMappingError;

// Common
export const selectSuperAdminActionMessage = (state: RootState) => state.superadmin.actionMessage;
